<template>
  <div class="dialog-content">
    <div style="display: flex; padding: 10px 0">
      <img style="width: 80px; height: 80px" :src="detail.data.serviceCover" />
      <div style="width: 100%; margin-left: 20px; line-height: 30px">
        <el-row :gutter="10">
          <el-col :span="24">订单编号:{{ detail.data.orderNum }}</el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">顾客姓名:{{ detail.data.userName }}</el-col>
          <el-col :span="8">身份证号:</el-col>
          <el-col :span="8">联系电话:{{ detail.data.phone }}</el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">联系地址:{{ detail.data.serviceAddr }}</el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8"
            >订单类型:{{
              detail.data.serviceType == "1" ? "站点服务" : "上门服务"
            }}</el-col
          >
          <el-col :span="8">订单分类:</el-col>
          <el-col :span="8">服务人员:{{ detail.data.servicerName }}</el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">派单时间:{{ detail.data.dispatchTime }}</el-col>
          <el-col :span="8">上门时间:{{ detail.data.doorTime }}</el-col>
          <el-col :span="8">完成时间:{{ detail.data.completeTime }}</el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8"
            >片区:{{
              detail.data.extendInfo ? detail.data.extendInfo.userOwnArea : ""
            }}</el-col
          >
          <el-col :span="8">站点:{{ detail.data.serviceAgentName }}</el-col>
          <el-col :span="8">系统来源:</el-col>
        </el-row>
      </div>
    </div>
    <el-table
      :data="[
        {
          serviceName: detail.data.serviceName,
          status: detail.data.status,
        },
      ]"
      stripe
      style="width: 100%"
      min-height="300"
      size="mini"
    >
      <el-table-column label="标题" prop="serviceName"> </el-table-column>
      <el-table-column label="状态" prop="status"> </el-table-column>
    </el-table>
    <div style="padding: 10px 0">
      服务资料
      <!-- <el-button style="margin-left: 20px" size="mini">添加资料</el-button> -->
      <el-upload
        style="max-width: 300px"
        class="upload-demo"
        action="/api/sysConfig/upload"
        :on-success="handleSuccess"
        :file-list="detail.fileList"
        accept=".png,.jpg,.jpeg,.mp4,.avi"
        :before-remove="removeInServer"
        :on-preview="downloadFile"
      >
        <el-button size="mini">添加资料</el-button>
        <!-- <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过500kb
            </div> -->
      </el-upload>
    </div>
    <!-- <div style="padding: 10px 0">
      <h4>表单</h4>
      <p
        v-for="(fd, index) in detail.formData"
        :key="index"
        style="width: 300px; display: flex; justify-content: space-between"
      >
        {{ fd.title }}
        <span>
          <-!-- <el-link @click="$message.error('缺少浏览接口')" type="primary"
            >浏览</el-link
          > ---!->
          <el-link
            @click="
              downloadFile(
                '/api/serviceOrder/exportServiceOrderForm?orderFormId=' + fd.id
              )
            "
            type="primary"
            >下载</el-link
          >
        </span>
      </p>
    </div> -->
    <div v-if="detail.lastEval" style="padding: 10px 0; display: flex">
      客户满意度：<el-rate
        v-model="detail.lastEval.evalClass"
        :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
        text-color="#ff9900"
        show-score
        score-template="{value}"
      ></el-rate>
    </div>
    <div v-if="detail.lastEval" style="padding: 10px 0; display: flex">
      评论显示：<el-switch
        v-model="detail.lastEval.isShow"
        active-color="#13ce66"
        inactive-color="#ff4949"
        @change="setShowEval(detail.evalData.isShow)"
      ></el-switch
      ><span style="margin-left: 15px">开启后将在前台显示</span>
    </div>
    <div
      style="padding: 10px 0; display: flex"
      v-for="(item, index) in detail.evalData"
      :key="index"
    >
      <template v-if="item.replyId">
        商家回复：
        <div style="display: inline-flex; flex-direction: column">
          <div>{{ item.content }}</div>
          <div>
            <el-image
              v-if="item.imgUrls"
              style="width: 100px; height: 100px"
              :src="item.imgUrls"
              :preview-src-list="[item.imgUrls]"
            >
            </el-image>
          </div>
          <div>{{ item.createTime }} <span>更新</span></div>
        </div>
      </template>
      <template v-else>
        用户留言：
        <div style="display: inline-flex; flex-direction: column">
          <div>{{ item.content }}</div>
          <div v-if="item.imgUrls">
            <el-image v-for="url in item.imgUrls" :key="url"
              style="width: 100px; height: 100px;margin-right:10px;"
              :src="url"
              :preview-src-list="item.imgUrls"
            >
            </el-image>
          </div>
          <div>{{ item.createTime }} <span>更新</span></div>
        </div>
      </template>
    </div>
    <div  v-if="detail.lastEval" style="padding: 10px 0">
      商家回复
      <el-input
        type="textarea"
        :rows="3"
        v-model="reply"
        placeholder="给客户留言及备注，用户在订单中查看"
      >
      </el-input>
      <el-button type="primary" @click="submitRemark" size="mini"
        >提交</el-button
      >
    </div>
  </div>
</template>
<script>
import { isObject } from 'util';

export default {
  props: {
    detail: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      reply: "",
    };
  },
  mounted() {
    console.log(this.detail);
  },
  methods: {
    handleSuccess(response, file, fileList) {
      const i = response.lastIndexOf("/") + 1;
      file.name = response.substring(i);
      let orderData = `${this.detail.data.orderData};${response}`;
      if (!this.detail.data.orderData) {
        orderData = response;
      }
      this.$httpRequest
        .post("api/serviceOrder/commitOrderData", {
          orderId: this.detail.data.id,
          orderData: orderData,
        })
        .then((res) => {
          this.$message.success("上传成功");
        })
        .catch(() => {
          this.$message.error("上传失败");
          const index = fileList.indexOf(file);
          fileList.splice(index, 1);
        });
    },
    removeInServer(file, fileList) {
      const orderData = fileList
        .filter((f) => f != file)
        .map((f) => f.url)
        .join(";");
      this.$httpRequest
        .post("api/serviceOrder/commitOrderData", {
          orderId: this.detail.data.id,
          orderData: `${orderData}`,
        })
        .then((res) => {
          this.$message.success("删除成功");
          this.detail.data.orderData = orderData;
          const index = fileList.indexOf(file);
          fileList.splice(index, 1);
        })
        .catch(() => {});
      return false;
    },
    downloadFile(file) {
      let url = file;
      if (isObject(file) ) {
        url = file.url;
      }
      window.open(url, "_brank");
    },
    submitRemark() {
      if (!this.reply) {
        this.$message.error("请输入回复内容");
        return;
      }
      this.$httpRequest
        .post(
          "api/serviceOrder/replyOrderEval?orderId=" + this.detail.data.id,
          {
            replyId:
              this.detail.lastEval
                ? this.detail.lastEval.id
                : 0,
            comment: this.reply,
          }
        )
        .then((res) => {
          let dt = new Date();
          this.detail.evalData.push({
            replyId:
              this.detail.evalData.length > 0 &&
              this.detail.evalData[0].sellerId
                ? this.detail.evalData[0].id
                : null,
            content: this.reply,
            createTime: `${dt.getFullYear()}-${
              dt.getMonth() + 1
            }-${dt.getDay()} ${dt.getHours()}:${dt.getMinutes()}`,
          });
          this.reply = "";
        });
    },
    setShowEval(show) {
      this.$httpRequest
        .get("api/serviceOrder/setOrderEvalShow", {
          orderId: this.detail.data.id,
          show: show == true ? "1" : "0",
        })
        .then((res) => {});
    },
  },
};
</script>
<style scoped>
.el-upload-list__item .el-icon-close-tip {
  right: -105px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/schedule/order_detail.vue